import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page terms-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = { class: "glass-card terms-card" }
const _hoisted_5 = { class: "terms-updated" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Logo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.eyebrowLegal), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.jsonData.termsTitle), 1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-divider" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.jsonData.termsUpdated), 1),
        _createElementVNode("div", {
          innerHTML: _ctx.jsonData.termsBody
        }, null, 8, _hoisted_6)
      ])
    ])
  ], 64))
}